import { supabase } from "../supabase";

/**
 * Firestore 시절 메모/댓글/좋아요는 books 문서 안의 배열이었고,
 * 수정할 때마다 getDoc -> map -> updateDoc 을 했다 (BookDiscussion.js:41-53).
 * 두 명이 동시에 누르면 하나가 사라지는 구조였다.
 * 이제 각각 독립 행이라 그 문제가 없다.
 */

export async function addMemo({ bookId, userId, text, isPublic = false, location = null }) {
  const { data, error } = await supabase
    .from("memos")
    .insert({
      book_id: bookId,
      user_id: userId,
      text: text.trim(),
      is_public: isPublic,
      location: location?.trim() || null,
    })
    .select("id")
    .single();
  if (error) throw error;
  return data.id;
}

export async function updateMemo(memoId, { text, isPublic }) {
  const patch = {};
  if (text !== undefined) patch.text = text.trim();
  if (isPublic !== undefined) patch.is_public = isPublic;
  const { error } = await supabase.from("memos").update(patch).eq("id", memoId);
  if (error) throw error;
}

export async function deleteMemo(memoId) {
  // 댓글/좋아요는 on delete cascade 로 같이 사라진다
  const { error } = await supabase.from("memos").delete().eq("id", memoId);
  if (error) throw error;
}

export async function addReply({ memoId, userId, text }) {
  const { error } = await supabase
    .from("memo_replies")
    .insert({ memo_id: memoId, user_id: userId, text: text.trim() });
  if (error) throw error;
}

export async function deleteReply(replyId) {
  const { error } = await supabase.from("memo_replies").delete().eq("id", replyId);
  if (error) throw error;
}

/** 좋아요 토글. 예전엔 배열 전체를 다시 쓰던 자리. */
export async function toggleLike(memoId, userId, currentlyLiked) {
  if (currentlyLiked) {
    const { error } = await supabase
      .from("memo_likes")
      .delete()
      .eq("memo_id", memoId)
      .eq("user_id", userId);
    if (error) throw error;
  } else {
    const { error } = await supabase
      .from("memo_likes")
      .upsert({ memo_id: memoId, user_id: userId }, { onConflict: "memo_id,user_id" });
    if (error) throw error;
  }
}
